export default __webpack_public_path__ + "static/media/icon_usdt.71e84974.svg";